import {
  viomeApiInstance,
  viomeAuthApiInstance,
  viomeSmpApiInstance,
} from '@viome/viome-base/src/api/ApiConfig';

export const CALLER_HEADER = 'X-Viome-Caller';
export const CALLER_VALUE = 'xfe-v2';

// Identifies xfe-v2 to Viome backends. Only add this header to hosts whose CORS
// preflight allows it (any header, or an explicit list containing it) —
// otherwise the browser blocks the whole request.
export const registerCallerHeader = () => {
  [viomeApiInstance, viomeAuthApiInstance, viomeSmpApiInstance].forEach(
    (instance) => {
      instance.interceptors.request.use((request) => {
        request.headers[CALLER_HEADER] = CALLER_VALUE;
        return request;
      });
    },
  );
};
